import { gql } from "@apollo/client";

const GET_REMITO_BNP_DOCUMENTO = gql`
    query archivoRemitoBNP($numeroRemito: String!) {
        archivoRemitoBNP(numeroRemito: $numeroRemito) {
            success,
            error,
            valorEsperado {
              idArchivo,
              idTipoArchivoDocumento,
              idOrdenPedido,
              archivo,
              titulo,
              extension,
              fechaAlta              
            }
        }
    }
`;

export default GET_REMITO_BNP_DOCUMENTO;

export const adaptRemitoBNPArchivo = (remito) => {
  return {
    idArchivo: remito?.idArchivo,
    idTipoArchivoDocumento: remito?.idTipoArchivoDocumento,
    numeroRemito: remito?.numeroRemito,
    idOrdenPedido: remito?.idOrdenPedido,
    contentType: remito?.contentType,
    titulo: remito?.titulo,
    archivo: remito?.archivo,
    extension: remito?.extension,
    fechaAlta: remito?.fechaAlta
  };
};